/* 공항정보 상세보기 */
$(".airportsInfo").on("click",function(e){
    e.preventDefault();

    var data = $(this).data('json');

    $("#airport_code").val( data.code );
    $("#airport_kname").val( data.k_name );
    $("#airport_ename").val( data.e_name );
    if( data.country ) {
        $("#airport_country").val(data.country).prop("selected", true);
        subListChanged("#airport_country", "#airport_city");
        $("#airport_city").val(data.city).prop("selected", true);
    }
    $("#airport_address").val( data.address );
    $("#airport_favorite").prop('checked', data.favorite );
    $("#airport_image").html('<img src="' + $(this).data('image') + '" class="airport_image">');

    $("#airport_modal_id").text( data.id );
    $("#airport_modal_code").text( data.code );
    $("#airport_modal_title").text( data.k_name );

    $("#airport_form").attr('action',"airports/" + data.id );

    $('.selectpicker').selectpicker('refresh');
});


/* 국가 리스트 선택시 도시 리스트 생성 */
$("#airport_country").change( function(){
    subListChanged("#airport_country", "#airport_city");
} );